export const moduleName = "terrain-height-tools";

export const socketName = `module.${moduleName}`;

export const defaultGroupName = "default";

export const moduleDrawingGroupName = `${moduleName}.rulers`;

export const wallHeightModuleName = "wall-height";

export const heightMapProviderId = `${moduleName}.heightMap`;

export const updateTerrainHook = `${moduleName}.updateTerrain`;

export const terrainHeightEditorControlName = "terrain-height-tools-editor";

// Number.EPSILON is too small for the tolerance when dealing with geometry since doing multiple arithmetic operations
// will compound the floating-point errors. 1e-10 is still a very small tolerance but enough to account for these errors
export const geometryTolerance = 1e-10;

/** @enum {keyof typeof tools} */
export const tools = /** @type {const} */ ({
	paint: "paint",
	erase: "erase",
	lineOfSight: "terrainHeightToolsLineOfSight",
	tokenLineOfSight: "terrainHeightToolsTokenLineOfSight",
	convert: "convert",
	terrainVisibility: "terrainVisibility"
});

/** @enum {keyof typeof drawingModeTypes} */
export const drawingModeTypes = /** @type {const} */ ({
	gridCells: "gridCells",
	rectangle: "rectangle",
	ellipse: "ellipse",
	customPoly: "customPoly",
	fill: "fill",
	pipette: "pipette",
	deleteShape: "deleteShape"
});

/** @enum {keyof typeof settingNames} */
export const settingNames = /** @type {const} */ ({
	defaultTokenLosTokenHeight: "defaultTokenLosTokenHeight",
	displayLosMeasurementGm: "displayLosMeasurementGm",
	displayLosMeasurementPlayer: "displayLosMeasurementPlayer",
	otherUserLineOfSightRulerOpacity: "otherUserLineOfSightRulerOpacity",
	paintToolbarUseHeightElevation: "paintToolbarUseHeightElevation",
	showTerrainHeightOnTokenLayer: "showTerrainHeightOnTokenLayer",
	showTerrainStackViewerOnTokenLayer: "showTerrainStackViewerOnTokenLayer",
	showZonesAboveNonZones: "showZonesAboveNonZones",
	smartLabelPlacement: "smartLabelPlacement",
	terrainHeightLayerVisibilityRadius: "terrainHeightLayerVisibilityRadius",
	terrainLayerAboveTilesDefault: "terrainLayerAboveTilesDefault",
	terrainStackViewerDisplayMode: "terrainStackViewerDisplayMode",
	terrainTypes: "terrainTypes",
	tokenElevationChange: "tokenElevationChange",
	tokenElevationChangeInsertClimbWaypoints: "tokenElevationChangeInsertClimbWaypoints",
	tokenLosToolPreselectToken1: "tokenLosToolPreselectToken1",
	tokenLosToolPreselectToken2: "tokenLosToolPreselectToken2",
	toolbarAutofade: "toolbarAutofade",
	toolbarPosition: "toolbarPosition",
	useFractionsForLabels: "useFractionsForLabels"
});

/** @enum {keyof typeof keybindings} */
export const keybindings = /** @type {const} */ ({
	decreaseLosRulerHeight: "decreaseLosRulerHeight",
	increaseLosRulerHeight: "increaseLosRulerHeight",
	showTerrainStack: "showTerrainStack",
	toggleTerrainHeightMapOnTokenLayer: "toggleTerrainHeightMapOnTokenLayer"
});

/** @enum {keyof typeof sceneFlags} */
export const sceneFlags = /** @type {const} */ ({
	heightData: "heightData",
	invisibleTerrainTypes: "invisibleTerrainTypes",
	terrainLayerAboveTiles: "terrainLayerAboveTiles"
});

/** @enum {keyof typeof tokenFlags} */
export const tokenFlags = /** @type {const} */ ({
	ignoreAutoElevation: "ignoreAutoElevation"
});

/** @enum {keyof typeof regionFlags} */
export const regionFlags = /** @type {const} */ ({
	terrainTypeId: "terrainTypeId"
});

/** @enum {keyof typeof socketFuncs} */
export const socketFuncs = /** @type {const} */ ({
	drawLineOfSightRay: "drawLineOfSightRay",
	clearLineOfSightRay: "clearLineOfSightRay"
});

/** @enum {keyof typeof terrainPaintMode} */
export const terrainPaintMode = /** @type {const} */ ({
	additiveMerge: "TERRAINHEIGHTTOOLS.PaintMode.AdditiveMerge.Name",
	destructiveMerge: "TERRAINHEIGHTTOOLS.PaintMode.DestructiveMerge.Name",
	totalReplace: "TERRAINHEIGHTTOOLS.PaintMode.TotalReplace.Name"
});

/** @enum {keyof typeof terrainFillMode} */
export const terrainFillMode = /** @type {const} */ ({
	applicableBoundary: "TERRAINHEIGHTTOOLS.FillMode.ApplicableBoundary.Name",
	strictBoundary: "TERRAINHEIGHTTOOLS.FillMode.StrictBoundary.Name"
});

/** @enum {keyof typeof tokenRelativeHeights} */
export const tokenRelativeHeights = /** @type {const} */ ({
	[1]: "SETTINGS.DefaultTokenLosHeight.Choice.Top",
	[0.5]: "SETTINGS.DefaultTokenLosHeight.Choice.Middle",
	[0]: "SETTINGS.DefaultTokenLosHeight.Choice.Bottom"
});

/** @enum {keyof typeof toolbarPositions} */
export const toolbarPositions = /** @type {const} */ ({
	topCenter: "SETTINGS.TerrainHeightToolsToolbarPosition.Choice.TopCenter",
	bottomCenter: "SETTINGS.TerrainHeightToolsToolbarPosition.Choice.BottomCenter"
});

/** @enum {keyof typeof terrainStackViewerDisplayModes} */
export const terrainStackViewerDisplayModes = /** @type {const} */ ({
	auto: "SETTINGS.TerrainStackViewerDisplayMode.Choice.Auto",
	proportional: "SETTINGS.TerrainStackViewerDisplayMode.Choice.Proportional",
	compact: "SETTINGS.TerrainStackViewerDisplayMode.Choice.Compact"
});
